import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Rating from '@mui/material/Rating';
import Typography from '@mui/material/Typography';

export default function FullSizedProduct({ product }) {
    return (
        <Box width={'100%'}>
            <Grid container spacing={4} width={'60%'} marginX={'auto'}>
                <Grid size={{md: 7, xs: 12}}>
                    <Box height={{md: '520px', xs: '250px'}} bgcolor={'#dbdad9'}>
                        <Box component={'img'} src={product?.imageUrl} sx={{ width: '100%', height: 1, objectFit: 'cover' }} />
                    </Box>
                </Grid>
                <Grid size={{md: 5, xs: 12}}>
                    <Grid container alignContent={'center'} height={{md: '80%', xs: 'auto'}} spacing={2}>
                        <Grid size={12}>
                            {
                                product?.shop ? <Typography variant="body1" component={'p'} textAlign={'center'} color='text.secondary' fontSize={'18px'} fontWeight={'bold'}>Shop</Typography> : null
                            }
                            <Typography variant="body1" component={'p'} textAlign={'center'} color='text.secondary' fontSize={{md: '46px', xs: '26px'}} fontFamily={'DanmarkURW'} fontWeight={'bold'}>{product?.type}</Typography>
                        </Grid>
                        <Grid size={12}>
                            <Box display={'flex'} alignItems={'center'} justifyContent={'center'} mb={1}>
                                <Rating 
                                    value={product?.reviews} 
                                    readOnly
                                    sx={{ color: 'text.secondary', fontSize: '18px' }}
                                />
                                <Typography variant="body1" component={'p'} textAlign={'center'} color='text.secondary' ml={'10px'} fontSize={'18px'}>({product?.reviewAmount} Reviews)</Typography>
                            </Box>
                            <Typography variant="body1" component={'p'} textAlign={'center'} color='text.secondary' fontSize={{md: '18px', xs: '1rem'}}>{product?.name}</Typography>
                        </Grid>
                    </Grid>
                    <Grid container height={{md: '20%', xs: 'auto'}} alignContent={'flex-end'} marginTop={{xs: '10px', md: 'unset'}}>
                        <Grid size={4}>
                            {/* Price */}
                            <Box className="alignItemsCenter" height={'95%'} sx={{ borderTop: 'solid 1px #e4e4e3', borderBottom: 'solid 1px #e4e4e3' }}>
                                <Typography variant="body1" color='text.secondary' fontSize={'24px'}>{product?.price} &euro;</Typography>
                            </Box>
                        </Grid>
                        <Grid size={8}>
                            {/* Add To Card */}
                            <Button color='#FFF' variant='contained' fullWidth className='borderRadiusFlat borderWidth2 buttonPaddingY10' sx={{ boxShadow: 0, backgroundColor: 'text.secondary', color: '#FFF', textTransform: 'none', fontSize: '18px', maxHeight: '50px', width: {md: '309px', xs: '100%'} }}>Add To Cart</Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    )
}